// IMPORTANT: THIS FILE IS AUTO GENERATED AND OVERWRITTEN ON BUILD!
/* tslint:disable */
export const GITVERSION = {
  "dirty": false,
  "raw": "12.16.0-17-gb868c9a43",
  "hash": "gb868c9a43",
  "distance": 17,
  "tag": "12.16.0",
  "semver": {
    "options": {
      "loose": false,
      "includePrerelease": false
    },
    "loose": false,
    "raw": "12.16.0",
    "major": 12,
    "minor": 16,
    "patch": 0,
    "prerelease": [],
    "build": [],
    "version": "12.16.0"
  },
  "suffix": "17-gb868c9a43",
  "semverString": "12.16.0+17.gb868c9a43"
};
export const DATESTAMP = '2025-07-09 12:04:12';
/* tslint:enable */
